import { render, staticRenderFns } from "./ProjectStyleTwo.vue?vue&type=template&id=2ba793f5&"
import script from "./ProjectStyleTwo.vue?vue&type=script&lang=js&"
export * from "./ProjectStyleTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports